/**
 * @generated SignedSource<<4dc2a9af772149e40e42c2bc84c3b64a>>
 * @relayHash ce267ceef2f0a894d552099443cb6e47
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a21c1550670e2e22f2869f68c4d63f8e8bac0e2f1c0a47ffbab55e0dc4c7dad4

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type graphBranchesPageQuery$variables = {
  account: string;
  graph: string;
};
export type graphBranchesPageQuery$data = {
  readonly graph: {
    readonly branches: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"branchListItemFragment">;
        };
      }>;
    };
    readonly productionBranch: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"branchListItemFragment">;
    };
  };
};
export type graphBranchesPageQuery = {
  response: graphBranchesPageQuery$data;
  variables: graphBranchesPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "account"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "graph"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountSlug",
    "variableName": "account"
  },
  {
    "kind": "Variable",
    "name": "graphSlug",
    "variableName": "graph"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "branchListItemFragment"
  }
],
v4 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Deployment",
    "kind": "LinkedField",
    "name": "latestDeployment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      (v2/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "graphBranchesPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": "graph",
          "args": (v1/*: any*/),
          "concreteType": "Graph",
          "kind": "LinkedField",
          "name": "graphByAccountSlug",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Branch",
              "kind": "LinkedField",
              "name": "productionBranch",
              "plural": false,
              "selections": (v3/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BranchConnection",
              "kind": "LinkedField",
              "name": "branches",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BranchEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Branch",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": (v3/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "graphBranchesPageQuery",
    "selections": [
      {
        "alias": "graph",
        "args": (v1/*: any*/),
        "concreteType": "Graph",
        "kind": "LinkedField",
        "name": "graphByAccountSlug",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Branch",
            "kind": "LinkedField",
            "name": "productionBranch",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BranchConnection",
            "kind": "LinkedField",
            "name": "branches",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BranchEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Branch",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v4/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ce267ceef2f0a894d552099443cb6e47",
    "id": "a21c1550670e2e22f2869f68c4d63f8e8bac0e2f1c0a47ffbab55e0dc4c7dad4",
    "metadata": {},
    "name": "graphBranchesPageQuery",
    "operationKind": "query",
    "text": "query graphBranchesPageQuery(\n  $account: String!\n  $graph: String!\n) {\n  graph: graphByAccountSlug(accountSlug: $account, graphSlug: $graph) {\n    productionBranch {\n      id\n      ...branchListItemFragment\n    }\n    branches {\n      edges {\n        node {\n          id\n          ...branchListItemFragment\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment branchListItemFragment on Branch {\n  id\n  name\n  latestDeployment {\n    createdAt\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0cad5fb06de2f9abaa376d05afe2b525";

export default node;
